import React, {useEffect, useState} from 'react'
import { useNavigate } from 'react-router';
import { useAuth } from '../../../context/AuthContext';
import { useAlert } from '../../../context/AlertContext';
import { Key, PhoneAndroid } from '@mui/icons-material';
import { LinearProgress } from '@mui/material';
import associateAuthServices from '../associateAuthServices';

function LoginPage() {
    const {AppAlert} = useAlert();
    const {setAuthUser,setIsLoggedIn} = useAuth();
    const navigate = useNavigate();

    const [customerPhone,setCustomerPhone] = useState("");
    const [otp,setOtp]  = useState("");
    const [otpSent,setOtpSentStatus]  = useState(false);
    const [loading,setLoadingStatus] = useState(false);


    const requestOtp = () =>{
        setLoadingStatus(true);
        associateAuthServices.associateRequestOtp({phone:customerPhone}).then(res=>{
            AppAlert(res.msg);
            setOtpSentStatus(true);
        }).catch(error=>{
            AppAlert(error.msg,"error");
        }).finally(()=>{
            setLoadingStatus(false);
        })
    }

    const verifyOtp = () =>{
        setLoadingStatus(true);
        associateAuthServices.associateVerifyOtp({phone:customerPhone,otp:otp}).then(res=>{
            localStorage.setItem('authUser',JSON.stringify(res.data));
            setAuthUser(res.data);
            setIsLoggedIn(true);
            navigate("/")
        }).catch(error=>{
            AppAlert(error.msg,"error");
        }).finally(()=>{
            setLoadingStatus(false);
        })
    }
    
    

    return (
    <div className="container">
        <div className="row mt-5">
            <div className="col-md-8 text-center bg-dark  p-5 mt-5 border rounded-pill">
                <img src='/images/ghospital-logo.png' style={{width:"50%"}} />
            </div>
            <div className='col-md-4'>
                    <div className='card mt-5 border'>
                        <div className='card-header bg-dark text-white'>Login to continue.</div>
                        <div className='card-body'>
                            <div className="input-group mb-3">
                                <span className="input-group-text" ><PhoneAndroid/></span>
                                <input type="number" className="form-control" disabled={otpSent} placeholder="Your Phone Number"
                                    value={customerPhone}
                                    onChange={(e)=>{
                                        if(e.target.value.length<=10){
                                            setCustomerPhone(e.target.value)
                                        }
                                    }}
                                />
                            </div>
                            {otpSent &&
                                <div className="input-group mb-3">
                                    <span className="input-group-text" ><Key/></span>
                                    <input type="number" className="form-control" placeholder=""
                                        value={otp}
                                        onChange={(e)=>{
                                            if(e.target.value.length<=4){
                                                setOtp(e.target.value)
                                            }
                                        }}
                                    />
                                </div>
                            }
                            <div>
                                {loading ?
                                    <LinearProgress/>
                                    :
                                    <div className='float-end'>
                                        {otpSent ?
                                            <button className='btn btn-dark' onClick={verifyOtp} disabled={otp.length < 4} >Verify OTP</button>
                                            :
                                            <button className='btn btn-dark' onClick={requestOtp} disabled={customerPhone.length < 10} >Send OTP</button>
                                        }
                                    </div>
                                }
                            </div>
                            
                        </div>
                    </div>
                </div>
        </div>
    </div>
  )
}

export default LoginPage